import { SelectOption } from '../../classes'

export enum PortalRuleAPI {
  AVAILITY = 'availity',
  EVICORE = 'evicore',
  OPTUM = 'optum',
}

export const PortalRuleAPIList: SelectOption<string>[] = [
  {
    value: PortalRuleAPI.AVAILITY,
    viewValue: 'portal.rules.api.availity',
  },
  {
    value: PortalRuleAPI.EVICORE,
    viewValue: 'portal.rules.api.evicore',
  },
  {
    value: PortalRuleAPI.OPTUM,
    viewValue: 'portal.rules.api.optum',
  },
]

export const getPortalRuleAPIName = (value: PortalRuleAPI): string => {
  return PortalRuleAPIList.find((item) => item.value === value)?.viewValue || value
}
